/** Маски ввода и подписи полей. Совпадают с валидацией backend. */

const FIELD_LABELS: Record<string, string> = {
  company_code: 'Компания',
  login: 'Логин абонента',
  last_name: 'Фамилия',
  first_name: 'Имя',
  middle_name: 'Отчество',
  birth_date: 'Дата рождения',
  birth_place: 'Место рождения',
  sex: 'Пол',
  passport_series: 'Серия паспорта',
  passport_number: 'Номер паспорта',
  issue_date: 'Дата выдачи',
  issue_authority: 'Кем выдан',
  subdivision_code: 'Код подразделения',
  registration_address: 'Адрес регистрации',
  connection_address: 'Адрес подключения',
  tariff_code: 'Тарифный план',
  tv_package_code: 'ТВ-пакет «Смотрёшка»',
  phone: 'Контактный телефон',
  email: 'Электронная почта',
  contract_number: 'Номер договора',
}

const STATUS_LABELS: Record<string, string> = {
  draft: 'Черновик',
  ocr_done: 'Данные на проверке',
  pending_signature: 'Ожидает подписи',
  signed: 'Подписан',
  ready_for_billing: 'Готов к выгрузке',
  declined: 'Отказ от подписания',
}

const CONSENT_LABELS: Record<string, string> = {
  personal_data: 'Обработка персональных данных (152-ФЗ)',
  simple_signature: 'Использование простой электронной подписи',
}

const QUALITY_LABELS: Record<string, string> = {
  blur: 'снимок размыт',
  glare: 'на снимке блик',
  print_spoofing: 'документ похож на распечатку',
  lcd_spoofing: 'документ похож на снимок с экрана',
}

export function fieldLabel(name: string): string {
  return FIELD_LABELS[name] ?? name
}

export function statusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status
}

export function consentLabel(kind: string): string {
  return CONSENT_LABELS[kind] ?? kind
}

export function qualityLabel(issue: string): string {
  return QUALITY_LABELS[issue] ?? issue
}

export function listFields(names: string[]): string {
  return names.map(fieldLabel).join(', ')
}

/** ISO-дата (YYYY-MM-DD) → ДД.ММ.ГГГГ для показа. */
export function formatDate(iso: string | null): string {
  if (!iso) return '—'
  const [year, month, day] = iso.split('-')
  if (!year || !month || !day) return iso
  return `${day}.${month}.${year}`
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'medium' })
}

/**
 * Телефон в вид +7 (999) 123-45-67 по мере ввода.
 * Нормализацию к E.164 делает backend — здесь только читаемость.
 */
export function formatPhoneInput(raw: string): string {
  let digits = raw.replace(/\D/g, '')
  if (digits.startsWith('8')) digits = `7${digits.slice(1)}`
  if (!digits.startsWith('7')) digits = `7${digits}`
  digits = digits.slice(0, 11)

  const rest = digits.slice(1)
  let result = '+7'
  // Разделитель добавляем только когда за ним УЖЕ есть цифра (строгое >, а не >=),
  // иначе хвостовые «) » / «-» восстанавливаются на каждый ввод и backspace не
  // может стереть символ — номер «залипает».
  if (rest.length) result += ` (${rest.slice(0, 3)}`
  if (rest.length > 3) result += `) ${rest.slice(3, 6)}`
  if (rest.length > 6) result += `-${rest.slice(6, 8)}`
  if (rest.length > 8) result += `-${rest.slice(8, 10)}`
  return result
}

export function formatSubdivisionInput(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 6)
  return digits.length > 3 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : digits
}

export function digitsOnly(raw: string, maxLength: number): string {
  return raw.replace(/\D/g, '').slice(0, maxLength)
}

export function fullName(parts: {
  last_name: string | null
  first_name: string | null
  middle_name: string | null
}): string {
  return [parts.last_name, parts.first_name, parts.middle_name].filter(Boolean).join(' ')
}
